import { render, staticRenderFns } from "./ProductAsideEol.vue?vue&type=template&id=b093031e&"
import script from "./ProductAsideEol.vue?vue&type=script&lang=js&"
export * from "./ProductAsideEol.vue?vue&type=script&lang=js&"
import style0 from "./ProductAsideEol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports